(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advantage-slider"] && !Shopify.designMode) return;
  try {
    
  class AdvantageSlider {
    constructor(container) {
      this.container = container;
      // The container itself is the swiper element
      this.swiperEl = container.classList.contains('advantage-slider-swiper')
        ? container
        : container.querySelector('.advantage-slider-swiper');
      if (!this.swiperEl) return;

      this.settings = this.getSettings();
      this.init();
    }

    getSettings() {
      const data = this.swiperEl.dataset;
      return {
        loop: data.loop === 'true',
        autoplay: data.autoplay === 'true',
        autoplayDelay: parseInt(data.delay) || 5000,
        showNavigation: data.showNavigation === 'true',
        showPagination: data.showPagination === 'true',
      };
    }

    init() {
      const visibleSlides = this.swiperEl.querySelectorAll('.swiper-slide').length;
      if (visibleSlides === 0) return;

      const swiperConfig = {
        slidesPerView: 1,
        loop: this.settings.loop && visibleSlides > 1,
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      };

      // Add autoplay if enabled
      if (this.settings.autoplay && visibleSlides > 1) {
        swiperConfig.autoplay = {
          delay: this.settings.autoplayDelay,
          disableOnInteraction: false,
        };
      }

      // Add pagination if enabled
      if (this.settings.showPagination) {
        swiperConfig.pagination = {
          el: '.custom-swiper-pagination',
          clickable: true,
        };
      }

      // Add navigation if enabled
      if (this.settings.showNavigation) {
        swiperConfig.navigation = {
          nextEl: '.custom-swiper-button-next',
          prevEl: '.custom-swiper-button-prev',
        };
      }

      try {
        new Swiper(this.swiperEl, swiperConfig);
      } catch (error) {
        console.error('Advantage Slider initialization error:', error);
      }
    }
  }

  // Initialize all advantage sliders
  function initAdvantageSliders() {
    const sliders = document.querySelectorAll('.new-advantage-slider-section');
    sliders.forEach((slider) => {
      new AdvantageSlider(slider);
    });
  }

  runWhenSwiperReady(initAdvantageSliders);

  // Re-initialize on section load (for theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      const slider = event.target.querySelector('.new-advantage-slider-section');
      if (slider) {
        runWhenSwiperReady(function () {
          new AdvantageSlider(slider);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categories-slider-section"] && !Shopify.designMode) return;
  try {
    
  class CategoriesSlider {
    constructor(container) {
      this.container = container;
      // The container itself is the swiper element
      this.swiperEl = container.classList.contains('categories-slider-swiper')
        ? container
        : container.querySelector('.categories-slider-swiper');
      if (!this.swiperEl) return;

      this.settings = this.getSettings();
      this.init();
    }

    getSettings() {
      const data = this.swiperEl.dataset;
      return {
        loop: data.loop === 'true',
        autoplay: data.autoplay === 'true',
        autoplayDelay: parseInt(data.delay) || 5000,
        showNavigation: data.showNavigation === 'true',
        showPagination: data.showPagination === 'true',
      };
    }

    equalHeight() {
      let maxHeight = 0;
      const slides = this.swiperEl.querySelectorAll('.swiper-slide');
      slides.forEach((slide) => {
        slide.style.height = 'auto';
        maxHeight = Math.max(maxHeight, slide.offsetHeight);
      });
      slides.forEach((slide) => {
        slide.style.height = maxHeight + 'px';
      });
    }

    init() {
      const visibleSlides = this.swiperEl.querySelectorAll('.swiper-slide').length;
      if (visibleSlides === 0) return;

      const swiperConfig = {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: false,
        loop: this.settings.loop && visibleSlides > 1,
        on: {
          init: () => {
            this.equalHeight();
          },
          resize: () => {
            this.equalHeight();
          },
        },
      };

      // Add autoplay if enabled
      if (this.settings.autoplay && visibleSlides > 1) {
        swiperConfig.autoplay = {
          delay: this.settings.autoplayDelay,
          disableOnInteraction: false,
        };
      }

      // Add pagination if enabled
      if (this.settings.showPagination) {
        swiperConfig.pagination = {
          el: '.custom-swiper-pagination',
          clickable: true,
        };
      }

      // Add navigation if enabled
      if (this.settings.showNavigation) {
        swiperConfig.navigation = {
          nextEl: '.custom-swiper-button-next',
          prevEl: '.custom-swiper-button-prev',
        };
      }

      try {
        new Swiper(this.swiperEl, swiperConfig);
      } catch (error) {
        console.error('Categories Slider initialization error:', error);
      }
    }
  }

  // Initialize all categories sliders
  function initCategoriesSliders() {
    const sliders = document.querySelectorAll('.new-categories-slider-section');
    sliders.forEach((slider) => {
      new CategoriesSlider(slider);
    });
  }

  runWhenSwiperReady(initCategoriesSliders);

  // Re-initialize on section load (for theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      const slider = event.target.querySelector('.new-categories-slider-section');
      if (slider) {
        runWhenSwiperReady(function () {
          new CategoriesSlider(slider);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const mediaQuery = window.matchMedia('(max-width: 1023px)');

    function initFooterToggle() {
      document.querySelectorAll('.footer-block--menu .footer-column .h5').forEach(function (heading) {
        // avoid duplicate bindings
        if (heading.dataset.bound) return;
        heading.dataset.bound = 'true';

        heading.addEventListener('click', function (e) {
          if (!mediaQuery.matches) return;

          e.preventDefault();

          const nextEl = heading.nextElementSibling;
          if (nextEl && nextEl.classList.contains('footer-link-list')) {
            nextEl.style.display = nextEl.style.display === 'block' ? 'none' : 'block';
          }

          heading.classList.toggle('open-footer');
        });
      });
    }

    // Initial load
    if (mediaQuery.matches) {
      initFooterToggle();
    }

    // Handle resize
    mediaQuery.addEventListener('change', function (e) {
      if (e.matches) {
        initFooterToggle();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.querySelector('.header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.updateHeaderBounds();

      this.onResizeHandler = () => {
        this.setHeaderHeight();
        this.updateHeaderBounds();
      };

      window.matchMedia('(max-width: 1023px)').addEventListener('change', this.onResizeHandler);
      window.addEventListener('resize', this.onResizeHandler);

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.onScrollHandler();
    }

    updateHeaderBounds() {
      if (!this.header || this.header.classList.contains('shopify-section-header-sticky')) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const rect = this.header.getBoundingClientRect();

      this.headerBounds = {
        top: rect.top + scrollTop,
        bottom: rect.top + scrollTop + this.header.offsetHeight,
      };
    }

    activateSticky() {
      if (!this.header.classList.contains('shopify-section-header-sticky')) {
        this.header.classList.add('shopify-section-header-sticky');
        this.classList.add('header-wrapper--sticky-active');
      }
    }

    deactivateSticky() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.classList.remove('header-wrapper--sticky-active');
      this.updateHeaderBounds();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.matchMedia('(max-width: 1023px)').removeEventListener('change', this.onResizeHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.headerBounds.top) {
        this.header.classList.add('scrolled-past-header');
        this.activateSticky();

        if (this.headerIsAlwaysSticky) {
          this.currentScrollTop = scrollTop;
          return;
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.activateSticky();
      this.header.classList.add('shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.activateSticky();
      this.header.classList.add('animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.deactivateSticky();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-banner"] && !Shopify.designMode) return;
  try {
    
  class HomeBannerSlider {
    constructor(container) {
      this.container = container;
      // The container itself is the swiper element
      this.swiperEl = container.classList.contains('home-banner-swiper')
        ? container
        : container.querySelector('.home-banner-swiper');
      if (!this.swiperEl) return;

      this.settings = this.getSettings();
      this.init();
    }

    getSettings() {
      const data = this.swiperEl.dataset;
      return {
        loop: data.loop === 'true',
        autoplay: data.autoplay === 'true',
        autoplayDelay: parseInt(data.delay) || 5000,
        disableOnInteraction: data.disableOnInteraction === 'true',
      };
    }

    init() {
      const visibleSlides = this.swiperEl.querySelectorAll('.swiper-slide').length;
      if (visibleSlides === 0) return;

      const swiperConfig = {
        loop: this.settings.loop && visibleSlides > 1,
      };

      // Add autoplay if enabled
      if (this.settings.autoplay && visibleSlides > 1) {
        swiperConfig.autoplay = {
          delay: this.settings.autoplayDelay,
          disableOnInteraction: this.settings.disableOnInteraction,
        };
      }

      try {
        this.swiper = new Swiper(this.swiperEl, swiperConfig);
        this.queueSyncSlideHeights();
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('orientationchange', this.handleResize);
        this.setupObservers();
        this.swiperEl.querySelectorAll('.home-banner__slide-image img').forEach((img) => {
          if (img.complete) return;
          img.addEventListener('load', this.handleResize);
        });
        if (document.fonts && typeof document.fonts.ready?.then === 'function') {
          document.fonts.ready.then(this.handleResize).catch(() => {});
        }
      } catch (error) {
        console.error('Swiper initialization error:', error);
      }
    }

    handleResize = () => {
      this.queueSyncSlideHeights();
    };

    queueSyncSlideHeights() {
      if (this.syncRaf) {
        cancelAnimationFrame(this.syncRaf);
      }
      this.syncRaf = requestAnimationFrame(() => {
        this.syncRaf = requestAnimationFrame(() => {
          this.syncSlideHeights();
        });
      });
    }

    setupObservers() {
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => {
          this.handleResize();
        });
        this.resizeObserver.observe(this.swiperEl);
      }

      if (this.swiper?.on) {
        this.swiper.on('resize', this.handleResize);
        this.swiper.on('slideChangeTransitionEnd', this.handleResize);
      }
    }

    syncSlideHeights() {
      const slides = this.swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate) .home-banner__slide');
      if (!slides.length) return;

      this.swiperEl.classList.remove('home-banner--equalized');
      this.swiperEl.style.removeProperty('--home-banner-equal-height');
      this.swiperEl.style.height = '';
      slides.forEach((slide) => {
        slide.style.minHeight = '';
      });

      let maxImageHeight = 0;
      let maxContentHeight = 0;

      slides.forEach((slide) => {
        const image = slide.querySelector('.home-banner__slide-image img');
        const contentLayer = slide.querySelector('.home-banner__slide-content');
        const contentInner = slide.querySelector('.home-banner__content');
        if (image) {
          maxImageHeight = Math.max(maxImageHeight, image.getBoundingClientRect().height);
        }
        if (contentLayer && contentInner) {
          const layerStyles = window.getComputedStyle(contentLayer);
          const paddingTop = parseFloat(layerStyles.paddingTop) || 0;
          const paddingBottom = parseFloat(layerStyles.paddingBottom) || 0;
          const contentHeight = contentInner.getBoundingClientRect().height + paddingTop + paddingBottom;
          maxContentHeight = Math.max(maxContentHeight, contentHeight);
        }
      });

      const targetHeight = Math.ceil(Math.max(maxImageHeight, maxContentHeight));
      if (targetHeight <= 0) return;

      this.swiperEl.classList.add('home-banner--equalized');
      this.swiperEl.style.setProperty('--home-banner-equal-height', `${targetHeight}px`);
      this.swiperEl.style.height = `${targetHeight}px`;
    }

    destroy() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('orientationchange', this.handleResize);
      if (this.syncRaf) {
        cancelAnimationFrame(this.syncRaf);
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.swiper?.off) {
        this.swiper.off('resize', this.handleResize);
        this.swiper.off('slideChangeTransitionEnd', this.handleResize);
      }
      this.swiperEl.querySelectorAll('.home-banner__slide-image img').forEach((img) => {
        img.removeEventListener('load', this.handleResize);
      });
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }
      this.swiperEl.classList.remove('home-banner--equalized');
      this.swiperEl.style.removeProperty('--home-banner-equal-height');
      this.swiperEl.style.height = '';
      this.swiperEl.querySelectorAll('.home-banner__slide').forEach((slide) => {
        slide.style.minHeight = '';
      });
    }
  }

  // Initialize all home banner sliders
  function initHomeBannerSliders() {
    document.querySelectorAll('.home-banner').forEach((banner) => {
      mountHomeBannerSlider(banner);
    });
  }

  function mountHomeBannerSlider(banner) {
    if (banner.__homeBannerSlider) {
      banner.__homeBannerSlider.destroy();
    }
    banner.__homeBannerSlider = new HomeBannerSlider(banner);
  }

  runWhenSwiperReady(initHomeBannerSliders);

  function stopHomeBannerVideo(deferred) {
    if (!deferred) return;

    deferred.querySelectorAll('.js-youtube').forEach((iframe) => {
      try {
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
      } catch (error) {}
      iframe.src = 'about:blank';
      iframe.remove();
    });

    deferred.querySelectorAll('.js-vimeo').forEach((iframe) => {
      try {
        iframe.contentWindow.postMessage('{"method":"pause"}', '*');
      } catch (error) {}
      iframe.src = 'about:blank';
      iframe.remove();
    });

    deferred.querySelectorAll('video').forEach((video) => {
      video.pause();
      video.currentTime = 0;
      video.remove();
    });

    deferred.querySelectorAll('[data-home-banner-video-placeholder]').forEach((el) => el.remove());
    deferred.removeAttribute('loaded');
  }

  function buildHomeBannerYoutubeSrc(deferred) {
    const videoId = deferred.dataset.videoId;
    const origin = deferred.dataset.videoOrigin || window.location.origin;
    const loop = deferred.dataset.videoLoop === 'true';
    const params = new URLSearchParams({
      autoplay: '1',
      playsinline: '1',
      rel: '0',
      controls: '1',
      modestbranding: '1',
      enablejsapi: '1',
      origin: origin,
    });

    if (loop) {
      params.set('loop', '1');
      params.set('playlist', videoId);
    }

    return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
  }

  function buildHomeBannerVimeoSrc(deferred) {
    const videoId = deferred.dataset.videoId;
    const loop = deferred.dataset.videoLoop === 'true';
    let src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
    if (loop) src += '&loop=1';
    return src;
  }

  function loadHomeBannerExternalVideo(deferred) {
    const mediaType = deferred.dataset.mediaType;
    if (mediaType !== 'youtube' && mediaType !== 'vimeo') return;

    stopHomeBannerVideo(deferred);

    const iframe = document.createElement('iframe');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    iframe.setAttribute('title', deferred.dataset.videoTitle || 'Video');
    iframe.setAttribute('loading', 'lazy');

    if (mediaType === 'youtube') {
      iframe.className = 'js-youtube';
      iframe.src = buildHomeBannerYoutubeSrc(deferred);
    } else {
      iframe.className = 'js-vimeo';
      iframe.src = buildHomeBannerVimeoSrc(deferred);
    }

    deferred.appendChild(iframe);
    deferred.setAttribute('loaded', 'true');
  }

  function playHomeBannerModalMedia(modal) {
    if (!modal) return;

    const deferred = modal.querySelector('deferred-media');
    if (!deferred) return;

    const mediaType = deferred.dataset.mediaType;

    window.setTimeout(() => {
      if (mediaType === 'youtube' || mediaType === 'vimeo') {
        loadHomeBannerExternalVideo(deferred);
        return;
      }

      const video = deferred.querySelector('video');
      if (video) {
        video.play().catch(() => {});
      }
    }, 150);
  }

  function bindHomeBannerVideoOpeners(root) {
    root.querySelectorAll('modal-opener[data-modal]').forEach((opener) => {
      const button = opener.querySelector('button');
      const modalSelector = opener.getAttribute('data-modal');
      if (!button || !modalSelector) return;

      if (button.dataset.homeBannerVideoBound === 'true') return;
      button.dataset.homeBannerVideoBound = 'true';

      button.addEventListener('click', () => {
        const modal = document.querySelector(modalSelector);
        playHomeBannerModalMedia(modal);
      });
    });
  }

  function bindHomeBannerModalCloses(root) {
    root.querySelectorAll('modal-dialog').forEach((modal) => {
      const closeBtn = modal.querySelector('.modal-video__toggle');
      if (!closeBtn || closeBtn.dataset.homeBannerCloseBound === 'true') return;
      closeBtn.dataset.homeBannerCloseBound = 'true';

      closeBtn.addEventListener('click', () => {
        stopHomeBannerVideo(modal.querySelector('deferred-media'));
      });
    });
  }

  function initHomeBannerVideo(root) {
    bindHomeBannerVideoOpeners(root);
    bindHomeBannerModalCloses(root);
  }

  function initHomeBannerRoots() {
    document.querySelectorAll('.home-banner-root').forEach((root) => {
      initHomeBannerVideo(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeBannerRoots);
  } else {
    initHomeBannerRoots();
  }

  document.addEventListener('modalClosed', () => {
    document.querySelectorAll('.home-banner-root deferred-media').forEach(stopHomeBannerVideo);
  });

  // Re-initialize on section load (for theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      const root = event.target.querySelector('.home-banner-root');
      if (root) {
        initHomeBannerVideo(root);
      }

      const banner = event.target.querySelector('.home-banner');
      if (banner) {
        runWhenSwiperReady(function () {
          mountHomeBannerSlider(banner);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-faq-section"] && !Shopify.designMode) return;
  try {
    
  // Simple accordion functionality for FAQ section
  document.addEventListener('DOMContentLoaded', function () {
    const accordion = document.getElementById('new-accordion');
    if (accordion) {
      const details = accordion.querySelectorAll('details');
      details.forEach((detail) => {
        detail.addEventListener('toggle', function () {
          if (this.open) {
            details.forEach((otherDetail) => {
              if (otherDetail !== this && otherDetail.open) {
                otherDetail.open = false;
              }
            });
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  class FAQAccordion {
    constructor(selector, options = {}) {
      this.accordion = document.querySelector(selector);
      if (!this.accordion) return;

      this.items = this.accordion.querySelectorAll('.accordion-block');

      this.settings = {
        singleOpen: options.singleOpen ?? true,
        defaultOpenIndex: options.defaultOpenIndex ?? null,
      };

      this.init();
    }

    init() {
      this.items.forEach((item, index) => {
        const trigger = item.querySelector('[data-role="trigger"]');
        const content = item.querySelector('[data-role="content"]');

        if (!trigger || !content) return;

        trigger.addEventListener('click', () => {
          const isOpen =
            item.classList.contains('is-active') ||
            (item.classList.contains('allow') && item.classList.contains('active'));

          if (this.settings.singleOpen) {
            this.items.forEach((other) => {
              if (other !== item) this.close(other);
            });
          }

          isOpen ? this.close(item) : this.open(item);
        });
      });

      if (this.settings.defaultOpenIndex !== null && this.items[this.settings.defaultOpenIndex]) {
        this.open(this.items[this.settings.defaultOpenIndex]);
      }
    }

    open(item) {
      item.classList.add('is-active', 'allow', 'active');
      const content = item.querySelector('[data-role="content"]');
      if (content) {
        content.style.display = 'block';
      }
    }

    close(item) {
      item.classList.remove('is-active', 'allow', 'active');
      const content = item.querySelector('[data-role="content"]');
      if (content) {
        content.style.display = 'none';
      }
    }
  }

  function initFAQAccordion() {
    new FAQAccordion('#faq-accordion', {
      singleOpen: true,
      defaultOpenIndex: null,
    });
  }

  function initReadMoreButton() {
    const readMoreButton = document.querySelector('.read_more_button_living_room');
    const readMoreContent = document.querySelector('.read_more_content_living_room');

    if (!readMoreButton || !readMoreContent) return;

    readMoreButton.addEventListener('click', function () {
      // Toggle visibility (similar to jQuery .toggle())
      const isVisible =
        readMoreContent.offsetParent !== null && window.getComputedStyle(readMoreContent).display !== 'none';

      if (isVisible) {
        readMoreContent.style.display = 'none';
      } else {
        readMoreContent.style.display = '';
      }

      // Check visibility after toggle
      const isNowVisible =
        readMoreContent.offsetParent !== null && window.getComputedStyle(readMoreContent).display !== 'none';
      const currentText = readMoreButton.textContent.trim();

      if (isNowVisible) {
        if (currentText === 'Read More') {
          readMoreButton.textContent = 'Read Less';
        } else if (currentText === 'Lire la suite') {
          readMoreButton.textContent = 'Lire moins';
        }
      } else {
        if (currentText === 'Read Less') {
          readMoreButton.textContent = 'Read More';
        } else if (currentText === 'Lire moins') {
          readMoreButton.textContent = 'Lire la suite';
        }
      }
    });
  }

  function initAll() {
    initFAQAccordion();
    initReadMoreButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-no-drill-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function stopModalVideo(deferred) {
      if (!deferred) return;

      deferred.querySelectorAll('.js-youtube').forEach((iframe) => {
        try {
          iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
        } catch (error) {}
        iframe.src = 'about:blank';
        iframe.remove();
      });

      deferred.querySelectorAll('.js-vimeo').forEach((iframe) => {
        try {
          iframe.contentWindow.postMessage('{"method":"pause"}', '*');
        } catch (error) {}
        iframe.src = 'about:blank';
        iframe.remove();
      });

      deferred.querySelectorAll('video').forEach((video) => {
        video.pause();
        video.currentTime = 0;
        video.remove();
      });

      deferred.querySelectorAll('[data-no-drill-banner-video-placeholder]').forEach((el) => el.remove());
      deferred.removeAttribute('loaded');
    }

    function buildYoutubeSrc(deferred) {
      const videoId = deferred.dataset.videoId;
      const origin = deferred.dataset.videoOrigin || window.location.origin;
      const loop = deferred.dataset.videoLoop === 'true';
      const params = new URLSearchParams({
        autoplay: '1',
        playsinline: '1',
        rel: '0',
        controls: '1',
        modestbranding: '1',
        enablejsapi: '1',
        origin: origin,
      });

      if (loop) {
        params.set('loop', '1');
        params.set('playlist', videoId);
      }

      return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
    }

    function buildVimeoSrc(deferred) {
      const videoId = deferred.dataset.videoId;
      const loop = deferred.dataset.videoLoop === 'true';
      let src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      if (loop) src += '&loop=1';
      return src;
    }

    function loadExternalVideo(deferred) {
      const mediaType = deferred.dataset.mediaType;
      if (mediaType !== 'youtube' && mediaType !== 'vimeo') return;

      stopModalVideo(deferred);

      const iframe = document.createElement('iframe');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      );
      iframe.setAttribute('title', deferred.dataset.videoTitle || 'Video');
      iframe.setAttribute('loading', 'lazy');

      if (mediaType === 'youtube') {
        iframe.className = 'js-youtube';
        iframe.src = buildYoutubeSrc(deferred);
      } else {
        iframe.className = 'js-vimeo';
        iframe.src = buildVimeoSrc(deferred);
      }

      deferred.appendChild(iframe);
      deferred.setAttribute('loaded', 'true');
    }

    function playModalMedia(modal) {
      if (!modal) return;

      const deferred = modal.querySelector('deferred-media');
      if (!deferred) return;

      const mediaType = deferred.dataset.mediaType;

      window.setTimeout(() => {
        if (mediaType === 'youtube' || mediaType === 'vimeo') {
          loadExternalVideo(deferred);
          return;
        }

        const video = deferred.querySelector('video');
        if (video) {
          video.play().catch(() => {});
        }
      }, 150);
    }

    function bindVideoOpeners(section) {
      section.querySelectorAll('modal-opener[data-modal]').forEach((opener) => {
        const button = opener.querySelector('button');
        const modalSelector = opener.getAttribute('data-modal');
        if (!button || !modalSelector) return;

        if (button.dataset.noDrillBannerVideoBound === 'true') return;
        button.dataset.noDrillBannerVideoBound = 'true';

        button.addEventListener('click', () => {
          const modal = document.querySelector(modalSelector);
          playModalMedia(modal);
        });
      });
    }

    function bindModalCloses(section) {
      section.querySelectorAll('modal-dialog').forEach((modal) => {
        const closeBtn = modal.querySelector('.modal-video__toggle');
        if (!closeBtn || closeBtn.dataset.noDrillBannerCloseBound === 'true') return;
        closeBtn.dataset.noDrillBannerCloseBound = 'true';

        closeBtn.addEventListener('click', () => {
          stopModalVideo(modal.querySelector('deferred-media'));
        });
      });
    }

    function bindImageModalBackdropClose(section) {
      const opener = section.querySelector('.section-no-drill-banner__image-opener[data-modal]');
      if (!opener) return;

      const modal = document.querySelector(opener.getAttribute('data-modal'));
      if (!modal || modal.dataset.imageModalBackdropBound === 'true') return;
      modal.dataset.imageModalBackdropBound = 'true';

      modal.addEventListener('pointerup', (event) => {
        if (!modal.hasAttribute('open')) return;
        if (event.target.closest('.section-no-drill-banner__modal-image, .modal-video__toggle')) return;
        modal.hide();
      });
    }

    function initFeaturesTabs(section) {
      const wrapper = section.querySelector('.section-no-drill-banner__features');
      if (!wrapper) return;

      const tabs = wrapper.querySelectorAll('.section-no-drill-banner__feature-tab');
      const panels = wrapper.querySelectorAll('.section-no-drill-banner__feature');
      if (!tabs.length || !panels.length) return;

      const mobileQuery = window.matchMedia('(max-width: 1023px)');

      function setActive(index) {
        tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.classList.toggle('is-active', selected);
        });

        panels.forEach((panel, i) => {
          const active = i === index;
          panel.classList.toggle('is-active', active);
          if (mobileQuery.matches) {
            panel.removeAttribute('hidden');
            panel.setAttribute('aria-hidden', active ? 'false' : 'true');
            if ('inert' in panel) {
              panel.inert = !active;
            }
          } else {
            panel.hidden = false;
            panel.removeAttribute('aria-hidden');
            panel.removeAttribute('inert');
          }
        });
      }

      function syncLayout() {
        if (mobileQuery.matches) {
          const activeIndex = Array.from(tabs).findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
          setActive(activeIndex >= 0 ? activeIndex : 0);
          return;
        }

        panels.forEach((panel) => {
          panel.hidden = false;
        });
      }

      tabs.forEach((tab, index) => {
        if (tab.dataset.featureTabBound === 'true') return;
        tab.dataset.featureTabBound = 'true';

        tab.addEventListener('click', () => {
          if (mobileQuery.matches) {
            setActive(index);
          }
        });
      });

      if (wrapper.dataset.featuresTabsResizeBound !== 'true') {
        wrapper.dataset.featuresTabsResizeBound = 'true';
        mobileQuery.addEventListener('change', syncLayout);
      }

      syncLayout();
    }

    function initMethodsSlider(section) {
      const wrapper = section.querySelector('.section-no-drill-banner__methods--mobile');
      const swiperEl = section.querySelector('.section-no-drill-banner__methods-swiper');
      if (!swiperEl || !wrapper) return;

      const mobileQuery = window.matchMedia('(max-width: 1023px)');

      function destroyMethodsSlider() {
        if (swiperEl.swiper) {
          swiperEl.swiper.destroy(true, true);
        }
        swiperEl.style.height = '';
        swiperEl.querySelectorAll('.swiper-slide').forEach((slide) => {
          slide.style.height = '';
        });
      }

      function equalizeMethodsSlideHeights() {
        const slides = swiperEl.querySelectorAll('.swiper-slide');
        if (!slides.length) return;

        let maxHeight = 0;
        swiperEl.style.height = 'auto';
        slides.forEach((slide) => {
          slide.style.height = 'auto';
        });
        slides.forEach((slide) => {
          maxHeight = Math.max(maxHeight, slide.offsetHeight);
        });

        if (maxHeight > 0) {
          swiperEl.style.height = maxHeight + 'px';
          slides.forEach((slide) => {
            slide.style.height = maxHeight + 'px';
          });
        }
      }

      function setupMethodsSlider() {
        const slides = swiperEl.querySelectorAll('.swiper-slide').length;
        const paginationEl = wrapper.querySelector('.section-no-drill-banner__methods-pagination');

        if (!mobileQuery.matches || slides <= 1) {
          destroyMethodsSlider();
          return;
        }

        if (swiperEl.swiper) {
          swiperEl.swiper.update();
          equalizeMethodsSlideHeights();
          return;
        }

        if (!paginationEl) return;

        try {
          new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            autoHeight: false,
            pagination: {
              el: paginationEl,
              clickable: true,
            },
            on: {
              init: () => {
                equalizeMethodsSlideHeights();
              },
              resize: () => {
                equalizeMethodsSlideHeights();
              },
            },
          });
        } catch (error) {
          console.error('Methods slider initialization error:', error);
        }
      }

      runWhenSwiperReady(setupMethodsSlider);

      if (wrapper.dataset.methodsSliderResizeBound !== 'true') {
        wrapper.dataset.methodsSliderResizeBound = 'true';
        mobileQuery.addEventListener('change', function () {
          runWhenSwiperReady(setupMethodsSlider);
        });
      }
    }

    function initSection(section) {
      bindVideoOpeners(section);
      bindModalCloses(section);
      bindImageModalBackdropClose(section);
      initFeaturesTabs(section);
      initMethodsSlider(section);
    }

    function init() {
      document.querySelectorAll('.section-no-drill-banner').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('modalClosed', () => {
      document.querySelectorAll('.section-no-drill-banner deferred-media').forEach(stopModalVideo);
    });

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        const section = event.target.querySelector('.section-no-drill-banner');
        if (section) {
          runWhenSwiperReady(function () {
            initSection(section);
          });
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-serie-opaque-plus"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function stopModalVideo(deferred) {
      if (!deferred) return;

      deferred.querySelectorAll('.js-youtube').forEach((iframe) => {
        try {
          iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
        } catch (error) {}
        iframe.src = 'about:blank';
        iframe.remove();
      });

      deferred.querySelectorAll('.js-vimeo').forEach((iframe) => {
        try {
          iframe.contentWindow.postMessage('{"method":"pause"}', '*');
        } catch (error) {}
        iframe.src = 'about:blank';
        iframe.remove();
      });

      deferred.querySelectorAll('video').forEach((video) => {
        video.pause();
        video.currentTime = 0;
        video.remove();
      });

      deferred.querySelectorAll('[data-serie-opaque-video-placeholder]').forEach((el) => el.remove());
      deferred.removeAttribute('loaded');
    }

    function buildYoutubeSrc(deferred) {
      const videoId = deferred.dataset.videoId;
      const origin = deferred.dataset.videoOrigin || window.location.origin;
      const loop = deferred.dataset.videoLoop === 'true';
      const params = new URLSearchParams({
        autoplay: '1',
        playsinline: '1',
        rel: '0',
        controls: '1',
        modestbranding: '1',
        enablejsapi: '1',
        origin: origin,
      });

      if (loop) {
        params.set('loop', '1');
        params.set('playlist', videoId);
      }

      return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
    }

    function buildVimeoSrc(deferred) {
      const videoId = deferred.dataset.videoId;
      const loop = deferred.dataset.videoLoop === 'true';
      let src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      if (loop) src += '&loop=1';
      return src;
    }

    function loadExternalVideo(deferred) {
      const mediaType = deferred.dataset.mediaType;
      if (mediaType !== 'youtube' && mediaType !== 'vimeo') return;

      stopModalVideo(deferred);

      const iframe = document.createElement('iframe');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      );
      iframe.setAttribute('title', deferred.dataset.videoTitle || 'Video');
      iframe.setAttribute('loading', 'lazy');

      if (mediaType === 'youtube') {
        iframe.className = 'js-youtube';
        iframe.src = buildYoutubeSrc(deferred);
      } else {
        iframe.className = 'js-vimeo';
        iframe.src = buildVimeoSrc(deferred);
      }

      deferred.appendChild(iframe);
      deferred.setAttribute('loaded', 'true');
    }

    function playModalMedia(modal) {
      if (!modal) return;

      const deferred = modal.querySelector('deferred-media');
      if (!deferred) return;

      const mediaType = deferred.dataset.mediaType;

      window.setTimeout(() => {
        if (mediaType === 'youtube' || mediaType === 'vimeo') {
          loadExternalVideo(deferred);
          return;
        }

        const video = deferred.querySelector('video');
        if (video) {
          video.play().catch(() => {});
        }
      }, 150);
    }

    function bindVideoOpeners(section) {
      section.querySelectorAll('modal-opener[data-modal]').forEach((opener) => {
        const button = opener.querySelector('button');
        const modalSelector = opener.getAttribute('data-modal');
        if (!button || !modalSelector) return;

        if (button.dataset.serieOpaqueVideoBound === 'true') return;
        button.dataset.serieOpaqueVideoBound = 'true';

        button.addEventListener('click', () => {
          const modal = document.querySelector(modalSelector);
          playModalMedia(modal);
        });
      });
    }

    function bindModalCloses(section) {
      section.querySelectorAll('modal-dialog').forEach((modal) => {
        const closeBtn = modal.querySelector('.modal-video__toggle');
        if (!closeBtn || closeBtn.dataset.serieOpaqueCloseBound === 'true') return;
        closeBtn.dataset.serieOpaqueCloseBound = 'true';

        closeBtn.addEventListener('click', () => {
          stopModalVideo(modal.querySelector('deferred-media'));
        });
      });
    }

    function initFeaturesTabs(section) {
      const wrapper = section.querySelector('.section-serie-opaque-plus__features');
      if (!wrapper) return;

      const tabs = wrapper.querySelectorAll('.section-serie-opaque-plus__feature-tab');
      const panels = wrapper.querySelectorAll('.section-serie-opaque-plus__feature');
      if (!tabs.length || !panels.length) return;

      const mobileQuery = window.matchMedia('(max-width: 1023px)');

      function setActive(index) {
        tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.classList.toggle('is-active', selected);
        });

        panels.forEach((panel, i) => {
          const active = i === index;
          panel.classList.toggle('is-active', active);
          if (mobileQuery.matches) {
            panel.removeAttribute('hidden');
            panel.setAttribute('aria-hidden', active ? 'false' : 'true');
            if ('inert' in panel) {
              panel.inert = !active;
            }
          } else {
            panel.hidden = false;
            panel.removeAttribute('aria-hidden');
            panel.removeAttribute('inert');
          }
        });
      }

      function syncLayout() {
        if (mobileQuery.matches) {
          const activeIndex = Array.from(tabs).findIndex(
            (tab) => tab.getAttribute('aria-selected') === 'true'
          );
          setActive(activeIndex >= 0 ? activeIndex : 0);
          return;
        }

        panels.forEach((panel) => {
          panel.hidden = false;
        });
      }

      tabs.forEach((tab, index) => {
        if (tab.dataset.featureTabBound === 'true') return;
        tab.dataset.featureTabBound = 'true';

        tab.addEventListener('click', () => {
          if (mobileQuery.matches) {
            setActive(index);
          }
        });
      });

      if (wrapper.dataset.featuresTabsResizeBound !== 'true') {
        wrapper.dataset.featuresTabsResizeBound = 'true';
        mobileQuery.addEventListener('change', syncLayout);
      }

      syncLayout();
    }

    function initMethodsSlider(section) {
      const wrapper = section.querySelector('.section-serie-opaque-plus__methods--mobile');
      const swiperEl = section.querySelector('.section-serie-opaque-plus__methods-swiper');
      if (!swiperEl || !wrapper) return;

      const mobileQuery = window.matchMedia('(max-width: 1023px)');

      function destroyMethodsSlider() {
        if (swiperEl.swiper) {
          swiperEl.swiper.destroy(true, true);
        }
        swiperEl.style.height = '';
        swiperEl.querySelectorAll('.swiper-slide').forEach((slide) => {
          slide.style.height = '';
        });
      }

      function equalizeMethodsSlideHeights() {
        const slides = swiperEl.querySelectorAll('.swiper-slide');
        if (!slides.length) return;

        let maxHeight = 0;
        swiperEl.style.height = 'auto';
        slides.forEach((slide) => {
          slide.style.height = 'auto';
        });
        slides.forEach((slide) => {
          maxHeight = Math.max(maxHeight, slide.offsetHeight);
        });

        if (maxHeight > 0) {
          swiperEl.style.height = maxHeight + 'px';
          slides.forEach((slide) => {
            slide.style.height = maxHeight + 'px';
          });
        }
      }

      function setupMethodsSlider() {
        const slides = swiperEl.querySelectorAll('.swiper-slide').length;
        const paginationEl = wrapper.querySelector('.section-serie-opaque-plus__methods-pagination');

        if (!mobileQuery.matches || slides <= 1) {
          destroyMethodsSlider();
          return;
        }

        if (swiperEl.swiper) {
          swiperEl.swiper.update();
          equalizeMethodsSlideHeights();
          return;
        }

        if (!paginationEl) return;

        try {
          new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            autoHeight: false,
            pagination: {
              el: paginationEl,
              clickable: true,
            },
            on: {
              init: () => {
                equalizeMethodsSlideHeights();
              },
              resize: () => {
                equalizeMethodsSlideHeights();
              },
            },
          });
        } catch (error) {
          console.error('Methods slider initialization error:', error);
        }
      }

      runWhenSwiperReady(setupMethodsSlider);

      if (wrapper.dataset.methodsSliderResizeBound !== 'true') {
        wrapper.dataset.methodsSliderResizeBound = 'true';
        mobileQuery.addEventListener('change', function () {
          runWhenSwiperReady(setupMethodsSlider);
        });
      }
    }

    function initSection(section) {
      bindVideoOpeners(section);
      bindModalCloses(section);
      initFeaturesTabs(section);
      initMethodsSlider(section);
    }

    function init() {
      document.querySelectorAll('.section-serie-opaque-plus').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('modalClosed', () => {
      document.querySelectorAll('.section-serie-opaque-plus deferred-media').forEach(stopModalVideo);
    });

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        const section = event.target.querySelector('.section-serie-opaque-plus');
        if (section) {
          runWhenSwiperReady(function () {
            initSection(section);
          });
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
